export default __webpack_public_path__ + "static/media/Immanuel_Billy.e352436d.png";